<script setup>
import { Link } from '@inertiajs/vue3'
import ConvictPhotos from '@images/convict-photos.jpg'
import HeadMetaTags from '@/Components/HeadMetaTags.vue'
</script>

<template>
  <HeadMetaTags
    title="Resources"
    description="Explore Convict Records resources! We've curated top research websites and created a community space where ancestry enthusiasts can connect and uncover Australia's convict history together."
    :canonical="route('resources')"
    :url="route('resources')"
  />

  <article class="prose mx-auto px-4 py-20 sm:px-6 lg:px-8">
    <h1>Convict Resources</h1>

    <h2>Get Talking!</h2>
    <p>
      We have started up a Facebook page for Convict Records which allows you to get in touch with
      other ancestry enthusiasts and get your questions answered.
    </p>
    <ul>
      <li>
        <a href="https://www.facebook.com/ConvictRecords">Visit us on facebook</a>
      </li>
    </ul>

    <h2>Convict Facts</h2>
    <p>
      We have compiled some interesting graphs and statistics based on our database and
      contributions made by site visitors. We believe some of this information may be the first and
      only of its kind. Want to know what the most common crimes committed by convicts are? What
      about the most common occupations? Read more on the
      <Link :href="route('facts')">convict facts</Link> page.
    </p>

    <h2>Databases used on this website</h2>
    <p>
      This site was made possible by the hard work of volunteers in association with the State
      Library of Queensland. They have put together some excellent information:
    </p>

    <p>
      At the time of writing, the British convict transportation registers 1787-1867 database used
      on this website is the only database of its kind to combine all the individual convict colony
      records into a central database.
    </p>

    <h2>Convict Research Sites</h2>
    <ul>
      <li>
        <a href="https://convictlandscapes.com.au" target="_blank"> Convict Landscapes </a>
        - Mapping project from the University of New England showing convict movements
      </li>
      <li>
        <a href="https://www.familysearch.org/wiki/en/Australia_Convict_Records" target="_blank">
          Family Search
        </a>
        - Australian Convicts Overview
      </li>
      <li>
        <a href="http://www.jenwilletts.com" target="_blank" class="external">
          Hunter Valley Convicts and Free Settlers
        </a>
        - Comprehensive resource focused on the Hunter Valley region of NSW
      </li>
      <li>
        <a href="http://femaleconvicts.org.au" target="_blank">
          Female Convicts Research Group (Tasmania)
        </a>
      </li>
      <li>
        <a href="http://www.historyaustralia.org.au/twconvic/tiki-index.php" target="_blank">
          Convict Stockade
        </a>
        wiki research site
      </li>
      <li>
        Convicts on
        <a href="http://en.wikipedia.org/wiki/Convicts_in_Australia" target="_blank">Wikipedia</a>
      </li>
      <li>
        First Fleet Convicts database by the
        <a href="http://firstfleet.uow.edu.au/search.html" target="_blank">
          University of Wollongong
        </a>
      </li>
      <li>
        Site rich with information for researchers
        <a href="http://www.hawkesbury.net.au/claimaconvict" target="_blank">Claim a Convict</a>
      </li>
    </ul>

    <h2>Pictures</h2>
    <img :src="ConvictPhotos" alt="Australian Convicts" />
    <p>
      There are only a handful of photos of Australian convicts - Tasmania and Western Australia
      were the only two colonies receiving new convicts when photography was available. We found
      some
      <a href="http://www.nla.gov.au/apps/cdview?pi=nla.pic-an11590418" target="_blank">
        convict photos
      </a>
      provided by the National Library of Australia.
    </p>
  </article>
</template>
